<template>
    <v-app>
        <v-content>
            <v-container class="primary wrapper">
                <router-view/>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>

export default {
    name: 'App',

};
</script>

<style>
.wrapper
{
    width:  100%;
    height: 100%;
    background-image: url("assets/background.png");
    background-size: cover;
}
</style>
